/**
 * 房间里的底部面板外壳：遮罩 + 停止冒泡 + 底部的关闭键（UI-SPEC §5.2 标准抽屉）。
 *
 * 以前只在 Transfer.tsx 里给座位名片 / 求购 / 流水三张面板共用；「我的座位」面板也要同一个壳，
 * 所以挪到这里。键盘契约（接管焦点、Tab 留在面板内、Esc 关闭、关后还焦点）由 useModalDialog 负责；
 * 刚弹出那一瞬间的点击由 useOpenTapGuard 截下（双击座位不会顺手点中面板里的「离开房间」）。
 *
 * 与 auth/sheetShell.tsx 不是一回事：那边是账号类面板（带标题栏与右上角 ×、portal 到 body），
 * 这边是牌局里的上下文面板，标题由各面板自己的 `.sheet__head` 画。
 */
import type { ReactNode } from 'react'

import { useModalDialog } from '../hooks/useModalDialog.js'
import { useOpenTapGuard } from '../hooks/useOpenTapGuard.js'

export interface SheetShellProps {
  /** 无障碍名字 */
  readonly label: string
  readonly onClose: () => void
  readonly children: ReactNode
}

export function SheetShell({ label, onClose, children }: SheetShellProps): ReactNode {
  const { dialogRef, onDialogKeyDown } = useModalDialog({ open: true, onClose })
  // 刚弹出的一瞬间不接点击：面板从被点的座位底下冒出来，双击的第二下会落在某一行上（见 useOpenTapGuard）
  const guardTap = useOpenTapGuard(true)
  return (
    <div className="sheet-scrim sheet-scrim--paper" onClickCapture={guardTap} onClick={onClose} role="presentation">
      <div
        className="sheet"
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-label={label}
        tabIndex={-1}
        onKeyDown={onDialogKeyDown}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
        <button type="button" className="btn btn--ghost sheet__close" onClick={onClose}>
          关闭
        </button>
      </div>
    </div>
  )
}

export default SheetShell
